import cx from 'classnames'
import React from 'react'

const ActionCardTemplate = ({
  CardIcon,
  image,
  label,
  labelClassName = '',
  labelWrapperClassName = '',
  imageWrapperClassName = '',
  sizeActionCard = 'medium',
  disabled = false
}) => {
  const textOnlyCard = !image && !CardIcon

  return (
    <div
      className={cx(
        '[ f-d-flc f-radius-card-large f-c-ba-whi f-c-fo-pri ] ActionCardTemplate ActionCardTemplate-compact',
        `ActionCardTemplate-${sizeActionCard}`,
        disabled && 'is-disabled'
      )}>
      {!textOnlyCard && (
        <div
          className={cx(
            'f-d-flr ActionCardTemplate-holder ActionCardTemplate-holder--compact',
            {
              'f-p-v-020': sizeActionCard === 'large',
              'f-p-t-030 f-p-b-005': sizeActionCard !== 'large',
              'ActionCardTemplate-holder--with-image': image,
              [imageWrapperClassName]: imageWrapperClassName
            }
          )}>
          {!image && CardIcon && <CardIcon />}
          {image && (
            <img
              className='ActionCardTemplate-image'
              {...image}
              alt={image.alt || label}
            />
          )}
        </div>
      )}
      <div
        className={cx(
          'f-d-flr f-t-centre ActionCardTemplate-text ActionCardTemplate-text--compact f-c-ba-bac015',
          labelWrapperClassName
        )}>
        <span className={cx('f-t-tbody f-m-h-010 f-c-fo-pri', labelClassName)}>
          {label}
        </span>
      </div>
    </div>
  )
}

export default ActionCardTemplate
